import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { DropDownMultiCheck } from "../../AdvanceSearch/DropDownMultiCheck";

import { useTranslation } from "react-i18next";
import Language from "../../AdvanceSearchTest/components/Language";

export default function DocOnlineListFilter({ searchObject, setSearchObject }) {
  const [skills, setSkills] = useState([]);
  const [jobRoles, setJobRoles] = useState([]);
  let { t } = useTranslation();
  useEffect(() => {
    CommonService.getTechSkills().then((data) => {
      setSkills(data);
    });
    CommonService.getAllJobRoles().then((data) => {
      setJobRoles(data);
    });
  }, []);
  function onChangeSkills(selecteds) {
    setSearchObject({ ...searchObject, skills: selecteds });
  }
  function onChange({ target }) {
    setSearchObject({ ...searchObject, [target.name]: target.value });
  }

  return (
    <>
      <div className="form-group">
        <label className="form-label">{t("Job Role")}</label>
        <div className="row">
          <div className="col">
            {" "}
            <select
              id="jobRoleId"
              name="jobRoleId"
              className="form-select"
              onChange={onChange}
              value={searchObject.jobRoleId}
            >
              <option value={""} selected>
                {t("Add a Role")}
              </option>
              {jobRoles &&
                jobRoles.map((item) => (
                  <option key={item.id} value={item.id}>
                    {t(item.description)}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>{" "}
      <div className="form-group">
        <label className="form-label">{t("Name or email")}</label>
        <div className="row">
          <div className="col">
            <input
              type="text"
              className="form-control"
              value={searchObject.nameOrEmail || ""}
              onChange={onChange}
              name="nameOrEmail"
            />
          </div>
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">{t("Years ofexperience")}</label>
        <div className="row">
          <div className="col">
            <input
              type="number"
              className="form-control"
              value={searchObject.yearsOfExperience || ""}
              onChange={onChange}
              name="yearsOfExperience"
            />
          </div>
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">{t("Skills")}</label>
        <div className="row">
          <div className="col">
            {" "}
            <DropDownMultiCheck
              dataList={skills}
              selecteds={searchObject.skills || []}
              setSelecteds={onChangeSkills}
              label={t("Skills...")}
              hideSelected={true}
            />
          </div>
        </div>
      </div>
      <Language
        searchObject={searchObject}
        setSearchObject={setSearchObject}
        onChange={onChange}
        t={t}
        errors={{}}
        hideSelected={true}
      />
    </>
  );
}
